<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.program.programList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">

                        <form role="form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.program.searchCriteria')}}</label>
                                        <v-select @input="loadPreset" label="name" :options="presetList"
                                            v-model="preset"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.program.programTitle')}}</label>
                                        <input type="text" v-model="search.title" @keyup="searchPrograms"
                                            class="form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.program.programCode')}}</label>
                                        <v-select @input="searchPrograms" :options="programCodes" v-model="search.code"
                                            :reduce="programCodes => programCodes">
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.program.programType')}}</label>
                                        <v-select @input="searchPrograms" :options="programTypes" v-model="search.type"
                                            :reduce="programTypes => programTypes">
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.program.academicYear')}}</label>
                                        <!-- <input type="date" v-model="search.academicYear" @change="searchPrograms"
                                            class="form-control"> -->
                                        <select v-model="search.year" @change="searchPrograms"
                                            class="form-control">
                                            <option v-for="(year , index) in programYears" :key="index" :value="year">
                                                {{year}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="detailedSearch">

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label for="">{{$t('form.program.notes')}}</label>
                                        <textarea v-model="search.notes" @keyup="searchPrograms" rows="5"
                                            class="form-control"></textarea>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <hr>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="text" v-model="preset.name" class="form-control"
                                            :placeholder="$t('form.program.presetName')">
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <button type="button" class="btn btn-primary"
                                        @click="savePreset">{{$t('button.save')}}</button>
                                    <button type="button" class="btn btn-danger" v-show="presetSelected"
                                        @click="deletePreset">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.program.programList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="programs.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.program.id')}}</th>
                                    <th>{{$t('form.program.academicYear')}}</th>
                                    <th>{{$t('form.program.programType')}}</th>
                                    <th>{{$t('form.program.programTitle')}}</th>
                                    <th>{{$t('form.program.transcriptTitle')}}</th>
                                    <th>{{$t('form.program.specialization')}}</th>
                                    <th>{{$t('form.program.major')}}</th>
                                    <th>{{$t('form.program.programCode')}}</th>
                                    <th class="text-right fix-action">{{$t('form.program.action')}}</th>
                                </tr>
                            </thead>

                            <tbody v-for="(program, index) in programs" v-bind:key="index">
                                <tr v-on:dblclick="editProgram(index)">
                                    <td>{{program.ID}}</td>
                                    <td>{{program.AcademicYear | formatDate('YYYY')}}</td>
                                    <td>{{program.ProgramType }}</td>
                                    <td>{{program.ProgramTitle}}</td>
                                    <td>{{program.TranscriptTitle}}</td>
                                    <td>{{program.Specialization}}</td>
                                    <td>{{program.Major}}</td>
                                    <td>{{program.ProgramCode}}</td>
                                    <td class="text-right">
                                        <button class="btn btn-info btn btn-sm personal_btn_info"
                                            v-on:click="editProgram(index , true)" v-show="permissions.viewPrograms">
                                            <span class="fa fa-copy"></span>
                                        </button>
                                        <button class="btn btn-info btn btn-sm personal_btn_info"
                                            v-on:click="editProgram(index)" v-show="permissions.viewPrograms">
                                            <span class="fa fa-edit"></span>
                                        </button>

                                        <button class="btn btn-danger btn btn-sm personal_btn_info"
                                            v-on:click="deleteProgram(index)" v-show="permissions.deletePrograms">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: ['permissions', 'dateFormat'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                alert: false,
                alertClass: '',
                alertMessage: '',

                detailedSearch: false,
                presetSelected: false,
                request_source: '',

                pagination: {
                    current_page: 1
                },

                search: {},

                preset: {
                    name: '',
                    entity: 'program',
                    value: {}
                },

                programCodes: [],
                programTypes: [],
                programYears: [],

                programs: [],
                presetList: []
            }
        },

        async mounted() {
            this.isLoading = true;
            
            if (!this.permissions.viewPrograms) {
                this.$router.push('/');
                return;
            }

            await this.initialData();

            if (localStorage.getItem('filter-program')) {
                this.search = JSON.parse(localStorage.getItem('filter-program'));
            }

            this.getPrograms();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-program', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {

            async initialData() {
                await axios
                    .get('/api/programs/initial-data')
                    .then(({
                        data
                    }) => {
                        this.programCodes = data.program_codes;
                        this.programTypes = data.program_types;
                        this.programYears = data.program_years;
                    })
                    .catch(error => console.log('error fetching initial data'));
            },

            getPrograms() {
                let source = axios.CancelToken.source();

                if (this.request_source != '') {
                    this.request_source.cancel('Operation canceled by the user.');
                    console.clear();
                }

                this.request_source = source;

                this.isLoading = true;

                axios
                    .get('/api/programs?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.programs = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            paginate() {
                this.getPrograms();
            },

            searchPrograms() {
                this.pagination.current_page = 1;
                this.getPrograms();
            },

            // Clear search input fields
            clearSearch() {
                this.search = {
                    code: '',
                    type: ''
                };

                this.searchPrograms();
            },

            editProgram(index , clone = false) {
                if (!this.permissions.viewPrograms) return;

                var id = this.programs[index].ID;

                this.$router.push({
                    name: clone ? "ProgramClone":"ProgramEdit",
                    params: {
                        id: id,
                        clone: clone,
                    }
                });

            },

            deleteProgram(index) {
                if (!this.permissions.deletePrograms) return;

                if (confirm(this.$t('form.validation.delete')) === true) {
                    this.isLoading = true;

                    axios
                        .delete('/api/programs/' + this.programs[index].ID)
                        .then(response => {

                            if (response.data.warning_course)
                                this.showAlert(response.data.message, 'danger');
                            else if (response.data.warning_student)
                                this.showAlert(response.data.message, 'danger');
                            else {
                                this.programs.splice(index, 1);
                                this.getPrograms();
                                this.showAlert(response.data.message);
                            }

                            this.isLoading = false;
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'program'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchPrograms();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>

<style scoped>

</style>
